export default /*@ngInject*/ function (homeDataService) {

    const vm = this;
    //State
    vm.currentView = 'library'; // 'library' or 'report'
    vm.backToLibrary = backToLibrary;

    // Instance tracking
    vm.libraryInstanceId = null;
    vm.reportInstanceId = null;

    vm.accessToken = null;
    vm.setReportView = setReportView;
    vm.embedManager = null;
    vm.themeId = 'modern';

    async function activate() {
        let authenticateResponse = await homeDataService.authenticateUser();
        vm.accessToken = authenticateResponse.data.Token;

        await getThemes();

        await window.initComposerEmbedManager({ "initialToken": vm.accessToken })
            .then(function (manager) {
                console.log('Embed manager initialized');
                vm.embedManager = manager;
            }).catch(function (err) {
                console.error('Failed to initialize embed manager:', err);
            });

        await setupReportLibraryComponent();
    }

    activate();

    async function getThemes() {
        const themesUrl = `${logiUrl}discovery/api/customization/themes`;
        const headers = {
            'Accept': 'application/vnd.composer.v3+json',
            'Content-Type': 'application/vnd.composer.v3+json',
            'Authorization': 'Bearer ' + vm.accessToken
        }
        const response = await fetch(themesUrl, { headers });
        const data = await response.json();

        if (data.content) {
            vm.themeId = data.content.filter(d => d.name === 'Delinea')[0].id;
        }
    }

    async function setupReportLibraryComponent() {
        vm.currentView = 'library';

        const componentConfig = {
            "inventoryItem": "report",
            "theme": vm.themeId,
            "components": {
                "filters": {
                    "visible": false,
                },
                "search": {
                    "visible": false,
                },
                actions: {
                    visible: true,
                    showDefaults: true,
                    order: ["import-report", "add-new-report"],
                    visibility: ["import-report", "add-new-report"],
                    definitions: [{
                        id: "add-new-report",
                        label: "Create Report",
                        intent: "primary",
                        onClick: async function () {
                            console.log('Create new report clicked');
                            await vm.setReportView(null);
                        }
                    }]
                },
                "table": {
                    "defaultSort": {
                        "colId": "name", // ["favorite", "name", "dataSource", "author", "dateModified", "permissions", "schedule", "actions"]
                        "sortDirection": "asc"
                    },

                    "columns": {
                        "showDefaults": true,

                        "order": [
                            "name",
                            "dataSource",
                            "author",
                            "dateModified",
                            "permissions",
                            "schedule",
                            "actions"
                        ],
                        "visibility": [
                            "name",
                            "dataSource",
                            "author",
                            "dateModified",
                            "permissions",
                            "schedule",
                            "actions"
                        ],


                        "definitions": [
                            {
                                colId: "name",
                                cellRendererParams: {
                                    onClick: async function (inventoryItem) {
                                        let reportId = inventoryItem.inventoryItemId;
                                        let reportName = inventoryItem.name;
                                        console.log('Opening report:', reportId, reportName);
                                        await vm.setReportView(reportId);
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            "interactivityOverrides": {
                "name": "interactive",
                "type": "SYSTEM",
                "overrideVisualInteractivity": true,
                "settings": {
                    "REFRESH": true,
                    "CHANGE_LAYOUT": true,
                    "RENAME": true,
                    "ADD_TO_FAVORITES": true,
                    "DELETE": true,
                    "SAVE": true,
                    "SAVE_AS": true,
                    "SCHEDULE_REPORTS": true,
                    "COMMENTS": true,
                    "EXPORT_PDF": true,
                    "EXPORT_XLSX": true,
                    "REPORT_HEADER_FOOTER": true,
                },
                "visualSettings": {
                    "KEYSET_ACTION": true,
                    "KEYSET": true,
                    "SETTINGS": true,
                    "FILTER": true,
                    "REMOVE": true,
                    "GROUPING": true,
                    "RENAME": true,
                    "SORT": true,
                    "TIMEBAR_FIELD": true,
                    "CONDITIONAL_FORMATTING": true,
                    "DETAILS_ACTION": true,
                    "INFO": true,
                    "SWITCH_REPORT": true,
                }
            },
        }


        let component = await vm.embedManager.createComponent("inventory", componentConfig);
        vm.libraryInstanceId = component.componentInstanceId;
        await component.render(document.getElementById("library-container"), { width: "100%", height: "100%" });
    }

    async function setReportView(reportId) {
        vm.currentView = 'report';

        const componentConfig = {
            "originId": "",
            "reportId": reportId,
            "interactivityProfileName": "interactive",
            "theme": vm.themeId,
            "editor": { "placement": "modals" },
            "header": {
                "showActions": true,
                "showTitle": true,
                "visible": true
            }
        };

        let component = await vm.embedManager.createComponent("report", componentConfig);
        vm.reportInstanceId = component.componentInstanceId;
        await component.render(document.getElementById("report-container"), { width: "100%", height: "100%" });
        await component.addEventListener('discovery-report-saved', async function (event) {
            console.log('Report saved event:', event);
            await vm.embedManager.refreshComponent(vm.libraryInstanceId);
        });
    }

    async function backToLibrary() {
        if (vm.reportInstanceId) {
            await vm.embedManager.removeComponent(vm.reportInstanceId);
        }

        vm.currentView = 'library';
        await vm.embedManager.refreshComponent(vm.libraryInstanceId);
    }
}
